import React from 'react';
import { Flex } from 'rebass/styled-components';
import { IBuilderCtrlViewProps } from '../types';

export const LineBreakCtrl: React.FC<IBuilderCtrlViewProps> = ({ properties }) => {
  return (
    <>
      <Flex style={{ width: '100%', height: '2px', backgroundColor: '#344f79' }} />
    </>
  );
};
